function createColorGradient() {
    return function numberToColor(value: number) {
        // Ensure the value is within the valid range
        const boundValue = Math.max(0, Math.min(100, value));

        const x = (boundValue / 100) * 255;
        return `rgb(255, ${x}, ${x})`; // Default Red
    };
}

export default createColorGradient;
